import { useState, useEffect } from "react";
import { askClaude } from "../utils/api";

export default function AIPanel({ title, prompt, systemPrompt = "", onClose, color, apiKey = "" }) {
  const [response, setResponse] = useState("");
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState("");

  const callAI = async () => {
    setLoading(true); setError(""); setResponse("");
    try {
      const text = await askClaude(prompt, systemPrompt, apiKey);
      setResponse(text);
    } catch (e) {
      setError(e.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { callAI(); }, []);

  return (
    <div style={{ position:"fixed", inset:0, background:"#000000dd", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
      <div style={{ background:"#0d0e1a", border:`1px solid ${color}44`, borderRadius:20, width:"100%", maxWidth:640, maxHeight:"85vh", display:"flex", flexDirection:"column", boxShadow:`0 0 60px ${color}22` }}>
        {/* Header */}
        <div style={{ padding:"16px 20px", borderBottom:`1px solid ${color}22`, display:"flex", alignItems:"center", gap:12 }}>
          <div style={{ fontSize:20 }}>🤖</div>
          <div style={{ flex:1 }}>
            <div style={{ fontWeight:800, fontSize:15, color:"#e2e8f0" }}>{title}</div>
            <div style={{ fontSize:11, color:"#475569", marginTop:2 }}>Claude Haiku via AWS Bedrock</div>
          </div>
          <button onClick={onClose} style={{ background:"#1e2030", border:"none", borderRadius:8, width:30, height:30, color:"#94a3b8", cursor:"pointer", fontSize:16 }}>×</button>
        </div>

        {/* Content */}
        <div style={{ flex:1, overflow:"auto", padding:20 }}>
          {loading ? (
            <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:16, padding:"40px 0" }}>
              <div style={{ fontSize:36 }}>🤖</div>
              <div style={{ color:"#64748b", fontSize:14 }}>Claude is thinking...</div>
              <div style={{ display:"flex", gap:6 }}>
                {[0, 1, 2].map(i => (
                  <div key={i} style={{ width:8, height:8, borderRadius:99, background:color, animation:`pulse 1s ease-in-out ${i * 0.2}s infinite` }} />
                ))}
              </div>
            </div>
          ) : error ? (
            <div>
              <div style={{ background:"#1a0a0a", border:"1px solid #F87171", borderRadius:10, padding:"14px 16px", marginBottom:16 }}>
                <div style={{ color:"#F87171", fontSize:13, marginBottom:8, fontWeight:700 }}>⚠ Error</div>
                <div style={{ color:"#94a3b8", fontSize:13 }}>{error}</div>
              </div>
              <button onClick={callAI} style={{ width:"100%", padding:"11px", background:color, border:"none", borderRadius:8, fontWeight:700, cursor:"pointer", fontFamily:"inherit", color:"#000" }}>
                Retry
              </button>
            </div>
          ) : response ? (
            <div>
              <div style={{ background:"#060810", border:`1px solid ${color}22`, borderRadius:12, padding:"16px 18px", whiteSpace:"pre-wrap", fontSize:14, color:"#94a3b8", lineHeight:1.8, fontFamily:"inherit" }}>
                {response}
              </div>
              <div style={{ display:"flex", gap:8, marginTop:14 }}>
                <button onClick={callAI} style={{ flex:1, padding:"10px", background:"transparent", border:`1px solid ${color}44`, borderRadius:8, color:"#64748b", cursor:"pointer", fontFamily:"inherit", fontSize:13 }}>↻ Ask Again</button>
                <button onClick={onClose} style={{ flex:2, padding:"10px", background:color, border:"none", borderRadius:8, fontWeight:700, cursor:"pointer", fontFamily:"inherit", fontSize:13, color:"#000" }}>Done ✓</button>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
